<template>
  <div id="modalSetCompany" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Selecionar Empresa</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="setCompany">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-sm-12">
                <label class="form-label">
                  Empresa: <span class="text-danger">*</span>
                </label>
                <select class="form-select" v-model="company">
                  <option value="" disabled>Selecione uma opção</option>
                  <option
                    :value="company"
                    v-for="company in companies"
                    :key="company.coligada"
                  >
                    Coligada: {{ company.coligada }} | Filial:
                    {{ company.filial }} | Nome: {{ company.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              title="Confirmar"
              :disabled="disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Confirmar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'SetCompanyModal',

  data() {
    return {
      company: '',
      disableButton: false,
    }
  },

  computed: {
    ...mapGetters(['companies']),
  },

  methods: {
    async setCompany() {
      if (!this.company.coligada) {
        this.$root.$refs.notification.warning(
          'Por favor, selecione uma empresa.',
        )
        return
      }

      this.disableButton = true
      try {
        await this.$store.dispatch('setCompany', this.company)

        hideModal()
        this.$emit('closeModal', true)
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    showModal('modalSetCompany')
  },
}
</script>
